<template>
  <div>
    <RowCard
      :theme="theme"
      class="align-start py-4"
      style="position: relative; min-height: 100px"
    >
      <div :style="{ width: headers[0].width }" class="flex-center ">
      </div>
      <div
        :style="{ width: headers[1].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        {{ item.no }}
      </div>
      <div
        :style="{ width: headers[2].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        {{ item.main_project?.fiscal_year }}
      </div>
      <div
        :style="{ width: headers[3].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        <div
          class="one-line mb-5"
          :class="[redText ? 'theme-color-seven' : 'black--text']"
          style="height: 20px"
        >
          {{ item.main_project?.name }}
        </div>
        <div
          v-if="item.main_project?.start_date && item.main_project?.end_date"
          class="one-line font-type-normal"
        >
          ระยะเวลาเปิดรับโครงการ :
          {{
            toDateRangeFormat(
              item.main_project.start_date,
              item.main_project.end_date
            )
          }}
        </div>
      </div>
      <div :style="{ width: headers[4].width }">
        {{ item.region }}
      </div>
      <div
        :style="{
          width: headers[5].width,
          color: statusColorSeparator(item.status),
        }"
      >
        {{ item.status }}
      </div>
      <div :style="{ width: headers[6].width }"></div>

      <v-btn
        absolute
        top
        right
        icon
        :class="{ rotate180: isExpanded }"
        @click="seeDetail"
      >
        <Iconify
          icon="material-symbols:keyboard-arrow-down"
          color="#D3D3D3"
        ></Iconify>
      </v-btn>
    </RowCard>

    <div class="expand-layout px-5" :class="[rand]">
      <div class="expand-content">
        <div class="d-flex justify-space-between gap-12 theme-color-eight">
          <div style="min-width: 8%; max-width: 8%"></div>
          <div style="min-width: 92%; max-width: 92%">แผนงาน</div>
        </div>

        <v-divider class="my-3"></v-divider>

        <div
          v-if="item.main_project && item.main_project.plan"
          class="d-flex flex-column gap-8"
        >
          <div v-for="(x, i) in item.main_project.plan" :key="i">
            <div class="d-flex justify-space-between align-center gap-12">
              <div style="min-width: 8%; max-width: 8%">
                <v-btn
                  small
                  icon
                  @click="editFormByType(x.form_b.id)"
                >
                  <v-icon color="#F15A29" size="15px"> mdi-pencil </v-icon>
                </v-btn>
              </div>
              <div style="min-width: 92%; max-width: 92%">
                {{ x.plan_master?.plan_name_th }}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "./input/Button";
import RowCard from "../components/RowCard";
import { toDateRangeFormat } from "../plugins/global-funcs";

export default {
  name: "RSPMonthlyProgressItem",
  components: {
    Button,
    RowCard,
  },
  props: {
    item: {
      default: () => ({}),
    },
    index: {
      default: 0,
    },
    headers: {
      default: () => [],
    },
  },
  data() {
    return {
      toDateRangeFormat,
      rand: "cl-" + Math.random().toString().slice(2),
      theme: 2,
      redText: false,
      isExpanded: false,
    };
  },
  methods: {
    seeDetail() {
      let growDiv = document.querySelector("." + this.rand + ".expand-layout");
      if (growDiv.clientHeight) {
        growDiv.style.height = 0;
        this.isExpanded = false;
      } else {
        let wrapper = document.querySelector(
          "." + this.rand + " .expand-content"
        );
        growDiv.style.height = wrapper.clientHeight + 20 + "px";
        this.isExpanded = true;
      }
    },
    statusColorSeparator(status) {
      switch (status) {
        case "Draft":
          this.theme = 2;
          this.redText = true;
          return "var(--theme-color-seven)";

        case "Submitted1":
          this.theme = 5;
          return "var(--theme-color-five)";

        case "Rejected":
          this.theme = 4;
          return "var(--theme-color-four)";

        case "Submitted2":
          this.theme = 10;
          return "var(--theme-color-ten)";

        case "Approved":
        case "Inception":
          this.theme = 3;
          return "var(--theme-color-three)";

        default:
          return "var(--theme-color-two)";
      }
    },
    editFormByType(id) {
      this.$router.push({
        name: "MonthlyProgressForm",
        query: { id: id, form_type: 'B' },
      });
    },
  },
};
</script>

<style scoped>
.left-side {
  min-width: 40px;
  max-width: 40px;
}

.btn-pos {
  position: absolute;
  bottom: 24px;
  right: 24px;
}

.expand-layout {
  -moz-transition: height 0.2s;
  -ms-transition: height 0.2s;
  -o-transition: height 0.2s;
  -webkit-transition: height 0.2s;
  transition: height 0.2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #fafafa;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
</style>
